<template>
	<div class="infographic" v-if="infographic">
		<img class="desktop" :class="{ifMobile: infographic.infographic_mobile}" :src="$imgUrl(infographic.infographic)" alt="">

		<img class="mobile" v-if="infographic.infographic_mobile" :src="$imgUrl(infographic.infographic_mobile)" alt="">
	</div>
</template>

<script>
export default {
	computed: {
		infographic() {
			let match = this.$store.state.client.customization?.infographic_translations?.find(t => t.attributes.lang === this.$store.state.endUser.language)

			if (match) {
				return match.attributes
			} else if (this.$store.state.client.customization && this.$store.state.client.customization.infographic) {
				return {
					infographic: this.$store.state.client.customization.infographic,
					infographic_mobile: this.$store.state.client.customization.infographic_mobile,
				}
			}

			return null
		}
	}
}
</script>
